export default __webpack_public_path__ + "static/clean-ingredients_real-people_Veena-8b04e1fa3c20492f4c037825f4570c87.png";